/* ==========================================================================
   BOUGHT IT ONLINE — bio-animations.js
   Animation layer for the custom theme (pairs with bio-theme.css).
   - Adds .bio-js to <html> so reveal states only apply when JS is live.
   - IntersectionObserver scroll-reveal for .bio-reveal elements.
   - Subtle hero parallax on .bio-hero__video / .bio-hero__poster.
   - Performance-safe: passive listeners, rAF-throttled, work is skipped
     entirely when the visitor prefers reduced motion (CSS also enforces).
   Upload as theme asset "bio-animations.js" and enqueue in theme.liquid:
     {{ 'bio-animations.js' | asset_url | script_tag }}
   ========================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.add('bio-js');

  /* ---- Scroll reveal ---------------------------------------------------- */
  var revealEls = document.querySelectorAll('.bio-reveal');
  if (revealEls.length) {
    if (reduceMotion || !('IntersectionObserver' in window)) {
      revealEls.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
      revealEls.forEach(function (el) { io.observe(el); });
    }
  }

  if (reduceMotion) {
    /* Make sure every hero video is paused; the poster carries the visual. */
    document.querySelectorAll('.bio-hero__video').forEach(function (v) {
      v.removeAttribute('autoplay');
      if (v.pause) v.pause();
    });
    return;
  }

  /* ---- Subtle hero parallax --------------------------------------------- */
  var heroes = Array.prototype.slice.call(document.querySelectorAll('.bio-hero'));
  if (!heroes.length) return;

  var ticking = false;
  function update() {
    ticking = false;
    var vh = window.innerHeight;
    heroes.forEach(function (hero) {
      var r = hero.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      /* progress: 0 when hero top hits viewport bottom, 1 when it leaves top */
      var p = (vh - r.top) / (vh + r.height);
      var shift = (p - 0.5) * 36; /* px, kept deliberately subtle */
      var media = hero.querySelectorAll('.bio-hero__video, .bio-hero__poster');
      media.forEach(function (m) {
        m.style.transform = 'translateY(' + shift.toFixed(1) + 'px) scale(1.06)';
      });
    });
  }
  function onScroll() {
    if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  update();

  /* ---- Pause hero videos when off-screen (battery/perf) ------------------ */
  if ('IntersectionObserver' in window) {
    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) { if (v.play) v.play().catch(function () {}); }
        else if (v.pause) v.pause();
      });
    }, { threshold: 0.05 });
    document.querySelectorAll('.bio-hero__video').forEach(function (v) { vio.observe(v); });
  }
})();
